export type ThemeMode = 'dark' | 'light';

export type ThemeVariables = Record<string, string>;

export const themeVariables: Record<ThemeMode, ThemeVariables> = {
    dark: {
        '--color-main': '#FFFFFF',
        '--background-primary': '#121212',
        '--bg-menu': '#1b1b1b',
        '--hover-menu': '#323232',
        '--text-menu': '#FFFFFF',
        '--overviewBlock-input-border': '#E0E0E0',
        '--background-accent': 'rgb(242, 109, 107)',
        '--background-accent-transparent': 'rgba(242, 109, 107, 0.42)',
        '--secondary': '#1F1F1F',
        '--card-sectionning-background-color': '#1F1F1F',
        '--card-background-color': '#181818',
        '--color': '#FFFFFF',
        '--form-element-background-color': '#121212',
        '--form-element-border-color': '#2C2B2B',
        '--status-active': '#2ECC71',
        '--status-waiting': '#F1C40F',
        '--background-status-waiting-subdued': 'rgba(241, 196, 15, 0.14)',
        '--background-success-subdued': 'rgba(89, 202, 89, 0.14)',
        '--text-success': 'rgba(89, 202, 89, 1)',
        '--background-accent-subdued': 'rgba(242, 109, 107, 0.14)',
        '--text-accent': 'rgb(242, 109, 107)',
        '--p-muted-color': '#565555',
        '--subscription-banner-background-color': '#6343E4',
        '--subscription-banner-free-background-color': 'rgba(255, 255, 255, 0.12)',
        '--banner-border-color': '#282727',
        '--background-additional': 'rgba(31, 31, 31, 1)',
        '--background-tertiary': 'rgba(255, 255, 255, 0.06)',
        '--background-quartary': 'rgba(255, 255, 255, 0.12)',
        '--border-primary': 'rgba(255, 255, 255, 0.06)',
        '--font-foreground': '#727171',
        '--approved-text-color': '#f5cd47',
        '--grid-text-color': '#9E9D9D',
        '--autocomplete-list-shadow-color': 'rgba(0, 0, 0, 0.15)',
        '--autocomplete-tag-close-color': '#c8c8c8',
        '--autocomplete-tag-close-hover-color': '#ffffff',
        '--schedule-action-button-color': '#BEBDBD',
        '--background-secondary': 'rgba(255, 255, 255, 0.04)',
        '--border-secondary': 'rgba(255, 255, 255, 0.12)',
        '--text-primary': '#ffffff',
        '--text-secondary': 'rgba(255, 255, 255, 0.56)',
        '--text-tertiary': 'rgba(255, 255, 255, 0.4)',
        '--icons-primary': 'rgba(255, 255, 255, 1)',
        '--icons-black-on-color': 'rgba(18, 18, 18, 1)',
        '--icons-primary-on-color': 'rgba(255, 255, 255, 1)',
        '--background-accent-hover': '#ff7c7a',
        '--popover-shadow-color': 'rgba(18, 18, 18, 0.16)',
        '--icons-secondary': 'rgba(255, 255, 255, 0.56)',
        '--icons-tertiary':'rgba(255, 255, 255, 0.4)',
        '--icons-disabled':'rgba(255, 255, 255, 0.12)',
        '--text-primary-on-color':'rgba(255, 255, 255, 1)',
        '--toggle-focus-outline-color': '#8a63d2',
        '--icons-accent':'rgba(242, 109, 107, 1)',
        '--icons-success':'rgba(89, 202, 89, 1)',
        '--icons-caution':'rgba(245, 205, 71, 1)',
        '--border-tertiary': 'rgba(255, 255, 255, 0.4)',
        '--background-secondary-not-transparent': '#1B1B1B',
        '--border-avatar': 'rgba(18, 18, 18, 1)',
        '--red-main': 'rgba(242, 109, 107, 1)',
        '--text-caution': 'rgba(245, 205, 71, 1)',
        '--background-primary-inverse': 'rgba(18, 18, 18, 0.88)'
    },
    light: {
        '--color-main': '#1F1F1F',
        '--background-primary': '#FFFFFF',
        '--bg-menu': '#F6F6F6',
        '--hover-menu': '#F2F4F7',
        '--text-menu': '#1F1F1F',
        '--overviewBlock-input-border': '#D1D5DB',
        '--background-accent': 'rgb(242, 109, 107)',
        '--background-accent-transparent': 'rgba(242, 109, 107, 0.42)',
        '--secondary': '#FFFFFF',
        '--card-sectionning-background-color': '#FFFFFF',
        '--card-background-color': '#FFFFFF',
        '--color': '#111827',
        '--form-element-background-color': '#FFFFFF',
        '--form-element-border-color': '#D1D5DB',
        '--status-active': '#1A7F37',
        '--status-waiting': '#B78103',
        '--background-status-waiting-subdued': 'rgba(183, 129, 3, 0.14)',
        '--background-success-subdued': 'rgba(89, 202, 89, 0.14)',
        '--text-success': 'rgba(89, 202, 89, 1)',
        '--background-accent-subdued': 'rgba(242, 109, 107, 0.14)',
        '--text-accent': 'rgb(242, 109, 107)',
        '--p-muted-color': '#6B7280',
        '--subscription-banner-background-color': '#6343E4',
        '--subscription-banner-free-background-color': 'rgba(18, 18, 18, 0.08)',
        '--banner-border-color': '#E5E7EB',
        '--background-additional': 'rgba(246, 246, 246, 1)',
        '--background-tertiary': 'rgba(15, 23, 42, 0.08)',
        '--background-quartary': 'rgba(18, 18, 18, 0.12)',
        '--border-primary': 'rgba(18, 18, 18, 0.08)',
        '--font-foreground': '#4B5563',
        '--approved-text-color': '#F5CD47',
        '--grid-text-color': '#374151',
        '--autocomplete-list-shadow-color': 'rgba(15, 23, 42, 0.15)',
        '--autocomplete-tag-close-color': '#6B7280',
        '--autocomplete-tag-close-hover-color': '#111827',
        '--schedule-action-button-color': '#1F2937',
        '--background-secondary': 'rgba(18, 18, 18, 0.04)',
        '--border-secondary': 'rgba(15, 23, 42, 0.15)',
        '--text-primary': 'rgba(18, 18, 18, 1)',
        '--text-secondary': 'rgba(18, 18, 18, 0.6)',
        '--text-tertiary': 'rgba(18, 18, 18, 0.4)',
        '--icons-primary': 'rgba(18, 18, 18, 1)',
        '--icons-black-on-color': 'rgba(18, 18, 18, 1)',
        '--icons-primary-on-color': 'rgba(255, 255, 255, 1)',
        '--background-accent-hover': '#ff7c7a',
        '--popover-shadow-color': 'rgba(18, 18, 18, 0.16)',
        '--icons-secondary': 'rgba(18, 18, 18, 0.6)',
        '--icons-tertiary':'rgba(18, 18, 18, 0.6)',
        '--icons-disabled':'rgba(18, 18, 18, 0.12)',
        '--text-primary-on-color':'rgba(255, 255, 255, 1)',
        '--toggle-focus-outline-color': '#8a63d2',
        '--icons-accent':'rgba(242, 109, 107, 1)',
        '--icons-success':'rgba(89, 202, 89, 1)',
        '--icons-caution':'rgba(245, 205, 71, 1)',
        '--border-tertiary': 'rgba(18, 18, 18, 0.6)',
        '--background-secondary-not-transparent': '#F6F6F6',
        '--border-avatar': 'rgba(255, 255, 255, 1)',
        '--red-main': 'rgba(242, 109, 107, 1)',
        '--text-caution': 'rgba(245, 205, 71, 1)',
        '--background-primary-inverse': 'rgba(255, 255, 255, 0.88)'
    },
};
